/*
 * Copyright (c) 2023 Bluemate B.V.
 */

import {getSetting} from '@dvrd/dvr-controls';

let isLoggedIn: boolean = false;
let inMaintenance: boolean = false;

export function setMaintenanceMode(mode: boolean) {
    inMaintenance = mode;
}

export function getMaintenanceMode() {
    return inMaintenance;
}

export const setMaintenanceLoggedIn = (loggedIn: boolean) => {
    isLoggedIn = loggedIn;
};

export const getMaintenanceLoggedIn = () => isLoggedIn;

export const requireMaintenanceLogin = (): boolean => getSetting('maintenanceMode') && !isLoggedIn;
